module.exports = __webpack_public_path__ + "static/media/bell_beaker_spain_text_02.6efa1253.jpg";